var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    role: "img",
    "aria-label": "VK",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#0077FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.5 34.6c-10.2 0-16-7-16.3-18.6h5.1c.2 8.5 3.9 12.1 6.9 12.8V16h4.8v7.4c2.9-.3 6-3.7 7.1-7.4h4.8c-.8 4.5-4.2 7.9-6.6 9.3 2.4 1.1 6.2 4 7.7 9.3h-5.3c-1.1-3.5-4-6.3-7.7-6.7v6.7h-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkLogo);
export default __webpack_public_path__ + "static/media/vk-logo.18099252461d51ef0768b29852b53d11.svg";
export { ForwardRef as ReactComponent };